import React from 'react';
import {Tooltip} from '../Tooltip/Tooltip';
import {BetSchema} from '../../api';

interface BetResultTooltipProps {
    bet: BetSchema;
    totalResult: number;
    children: React.ReactNode;
}

export const BetResultTooltip: React.FC<BetResultTooltipProps> = ({ bet, totalResult, children }) => {

    const hasStakeWin = bet.stake_profit !== null && bet.stake_profit! > 0;
    const hasStakeLose = bet.stake_profit !== null && bet.stake_profit! < 0;

    return (
        <Tooltip content={
            <div>
                {/* Прогноз */}
                <div>
                    Прогноз: {bet.classic_points != null && bet.classic_points >= 0 ? '+' : ''}{bet.classic_points ?? 0} балла(-ов)
                </div>
                <div style={{ fontSize: '0.8rem', color: 'var(--color-typo-secondary)' }}>
                    {bet.description || (bet.classic_points! > 0 ? 'Угадано' : 'Не угадано')}
                </div>

                {/* Джокер */}
                {bet.is_golden && (
                    <div style={{ fontSize: '0.8rem', color: '#f0b400', marginTop: 4 }}>
                        ×2 золотой джокер
                    </div>
                )}

                {/* Ставка */}
                {bet.stake! > 0 && (
                    <>
                        <div style={{ marginTop: 6, borderTop: '1px solid #333', paddingTop: 6 }}>
                            Ставка: {bet.stake_profit != null
                                ? `${bet.stake_profit >= 0 ? '+' : ''}${bet.stake_profit}`
                                : '—'}
                        </div>
                        <div style={{ fontSize: '0.8rem', color: 'var(--color-typo-secondary)', marginTop: 2 }}>
                            {hasStakeWin && (
                                <>
                                    Поставлено: {bet.stake} балла(-ов)
                                    <br />
                                    Коэффициент: ×{bet.coeff}
                                    {bet.is_all_in && <><br />Ва-банк: ×1.5</>}
                                    <br />
                                    Расчёт: {bet.stake} × {bet.coeff}{bet.is_all_in ? ' × 1.5' : ''} − {bet.stake} = +{bet.stake_profit}
                                </>
                            )}
                            {hasStakeLose && (
                                <>Поставлено {bet.stake} — не угадано, ставка сгорела</>
                            )}
                            {!hasStakeWin && !hasStakeLose && (
                                <>Поставлено: {bet.stake}{bet.is_all_in ? ' (ва-банк)' : ''}</>
                            )}
                        </div>
                    </>
                )}
            </div>
        }>
            {children}
        </Tooltip>
    );
};